// src/pages/dashboard/Dashboard.tsx
import { useEffect, useState } from 'react';
import { fetchDashboardData } from '@/services/api/dashboardApi';
import { DashboardData } from './DashboardData';
//import DashboardSummary from '/widgets/DashboardSummary';
import DashboardSummary from './widgets/DashboardSummary';
//import DashboardTransactions from './widgets/DashboardTransactions';
//import {DashboardTransactions} from './widgets/DashboardTransactions';
import { DashboardTransactions } from './widgets/DashboardTransactions';
import DashboardNetWorthChart from './widgets/DashboardNetWorthChart';

const Dashboard = () => {
  const [data, setData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const result = await fetchDashboardData();
        setData(result);
      } catch (err) {
        setError('Failed to load dashboard data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) return <div className="p-4">Loading...</div>;
  if (error) return <div className="p-4 text-red-500">{error}</div>;
  if (!data) return null;

  return (
    <div className="p-4 grid gap-4 lg:grid-cols-2">
  {/* Left column */}
  <div className="space-y-4">
    <DashboardSummary
      income={data.totalIncomeThisMonth}
      expenses={data.totalExpensesThisMonth}
      netIncome={data.netIncome}
    />
    <DashboardNetWorthChart data={data.netWorthChart} />
  </div>

  {/* Right column */}
  <div className="space-y-4">
    <DashboardTransactions transactions={data.recentTransactions} />
    {/* Optionally add SpendingChart, or another card here */}
  </div>
</div>
  );
};

export default Dashboard;
